<template>
  <header class="navbar is-bold">
    <div class="container">
      <div class="navbar-brand">
        <router-link class="navbar-item is-paddingless" :to="{ name: 'Home'}">
          <img class="logo" :src="require('../../assets/logo@2x.png')" alt="DBT: DBTracer Explorer">
        </router-link>
        <!-- <a class="navbar-item is-paddingless" href="http://www.dbton.com">
          <img :src="require('../../assets/logo.png')" alt="DBT: DBTracer Explorer">
        </a> -->
        <div class="navbar-burger burger" data-target="navbarDropdown">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div id="navbarDropdown" class="navbar-menu">
        <div class="navbar-start">
          <!-- network stats -->
          <router-link class="navbar-item is-hidden" :to="{ name: 'BlocksOverview' }">{{ $t("nav.blocks") }}</router-link>
        </div>

        <div class="navbar-end">
          <!-- home -->
          <router-link class="navbar-item" :to="{ name: 'Home'}">
            <span class="tag is-info is-medium">{{ $t("nav.home") }}</span>
          </router-link>
          <!-- faq -->
          <router-link class="is-hidden navbar-item" :to="{ name: 'Faq'}">
            <span class="tag is-info is-medium">{{ $t("nav.faq") }}</span>
          </router-link>
          <!-- ticker -->
          <router-link class="navbar-item" :to="{ name: 'Ticker'}">
            <span class="tag is-info is-medium">{{ $t("nav.ticker") }}</span>
          </router-link>
          <!-- tracer home -->
          <!-- <a class="navbar-item" href="https://www.dbton.com">
            <span class="tag is-info is-medium">{{ $t("nav.tracer_home") }}</span>
          </a> -->
          <!-- lang -->
          <!-- <div class="is-hidden navbar-item has-dropdown is-hoverable">
            <b-dropdown v-model="$i18n.locale" position="is-bottom-left">
              <a class="navbar-item" slot="trigger">
                <span v-bind:class=getLangFlag($i18n.locale)></span>
                &nbsp;&nbsp;
                <span>{{ getLangName($i18n.locale) }}</span>
              </a>
              <div v-for="(lang, i) in langs" :key="`Lang${i}`">
                <b-dropdown-item class="lang" v-bind:value="lang">
                  <span v-bind:class=getLangFlag(lang)></span>
                  &nbsp;&nbsp;
                  {{ getLangName(lang) }}
                </b-dropdown-item>
              </div>
            </b-dropdown>
          </div> -->
          <!-- search -->
          <div class="navbar-item last">
            <b-dropdown
              v-model="search"
              position="is-bottom-left"
              aria-role="menu">
              <a
                  class="navbar-item"
                  slot="trigger"
                  role="button">
                  <img class="img-search" :src="require('../../assets/search@2x.png')" alt="Search">
                  <!-- <span class="icon is-small is-right has-text-info">
                    <i class="fa fa-search"></i>
                  </span> -->
              </a>

              <b-dropdown-item custom aria-role="menuitem">
                <form @submit.prevent="onSubmit">
                  <div class="field has-addons">
                    <div class="control has-icons-right">
                      <input v-model="search" type="text" class="input is-shadowless is-radiusless" :placeholder="$t('faq.search_prompt')" style="min-width: 260px">
                    </div>
                    <div class="control is-hidden">
                      <button class="button is-primary" type="submit">{{ $t("nav.search") }}</button>
                    </div>
                  </div>
                </form>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <!-- -->
        </div>
      </div>
    </div>
  </header>
  <!--</div>
</section>-->
</template>

<script>
  export default {
    name: 'NavBar',
    methods: {
      onSubmit () {
        const search = this.search
        if (!search) {
          return
        }
        if (search.length <= 42) {
          this.$router.push({name: 'Contract', params: { hash: search }})
        } else {
          this.$router.push({name: 'Transaction', params: { hash: search }})
        }
      }
    },
    data () {
      return {
        search: '',
        langs: ['zhs', 'en', 'ja'],
        langNames: {
          'zhs': '简体中文',
          'en': 'English',
          'ja': '日本語'
        },
        langFlags: {
          'zhs': 'cn',
          'en': 'us',
          'ja': 'jp'
        }
      }
    }
  }

  /* burger navigation */
  document.addEventListener('DOMContentLoaded', function () {
    // Get all "navbar-burger" elements
    var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0)
    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {
      // Add a click event on each of them
      $navbarBurgers.forEach(function ($el) {
        $el.addEventListener('click', function () {
          // Get the target from the "data-target" attribute
          var target = $el.dataset.target
          var $target = document.getElementById(target)
          // Toggle the class on both the "navbar-burger" and the "navbar-menu"
          $el.classList.toggle('is-active')
          $target.classList.toggle('is-active')
        })
      })
    }
  })
</script>

<style lang="scss" scoped>
// Import Bulma and Buefy styles
@import "~bulma";

  .navbar {
    padding-top: 2rem;
    border-bottom: 1px solid #e0e0e0;
    background: transparent;

    .has-text-info {
      color: #fff!important;
    }
  }

  .navbar-burger {
    color: #fff;
  }

  a.navbar-item:hover {
    background:transparent;
  }

  a.navbar-item.is-active {
    // background:#4acb6b;
    background-color:transparent;
  }

  a.navbar-item:hover {
    background-color: #4acb6b60;
  }

  .logo {
    width: 175px;
    height: 25px;
    margin-left: 10px;
  }

  .img-search {
    width: 12.5px;
    height: 12.5px;
  }

  a {
    color: #4a4a4a;
  }

  a:hover {
    color: $primary;
  }

  a.lang:hover {
    color: #4a4a4a;
  }

  .navbar-end {
    padding-top: .2rem;
  }

  .navbar-item img {
    margin-top: 0.25rem;
    // margin-left: 1.5rem;
    max-height: 3.25rem;
  }

  .navbar-item {
    .tag {
      background: transparent!important;
      color: #fff!important;
    }
  }

  .navbar-brand > a{
    background-color: transparent!important;
  }

  .navbar-item.router-link-exact-active {
    .tag {
      font-weight: bold;
    }
  }

  .navbar-item {
    .control {
      border: none;
      background-color: transparent;
    }
    input {
      border: none;
      background-color: transparent;
      border-bottom: thin solid #eee;
    }
    .input:hover {
      border-color: #eee;
    }
    .input::placeholder {
      color: #e0e0e0;
    }
  }

  .navbar-menu {
    background: transparent;
  }

</style>




// WEBPACK FOOTER //
// src/components/layout/NavBar.vue